import { StyleSheet } from 'react-native';

export const createStyles = (theme: 'light' | 'dark' = 'light') => {
  const colors = {
    light: {
      background: '#FFFFFF',
      text: '#666666',
      activeText: '#333333',
      disabledText: '#CCCCCC',
      indicator: '#FF2442',
      border: '#F0F0F0',
      badge: '#FF2442',
      badgeText: '#FFFFFF',
    },
    dark: {
      background: '#1A1A1A',
      text: '#999999',
      activeText: '#FFFFFF',
      disabledText: '#555555',
      indicator: '#FF2442',
      border: '#333333',
      badge: '#FF2442',
      badgeText: '#FFFFFF',
    },
  };

  const c = colors[theme];

  return StyleSheet.create({
    container: {
      backgroundColor: c.background,
      borderBottomWidth: StyleSheet.hairlineWidth,
      borderBottomColor: c.border,
    },
    scrollView: {
      flexGrow: 0,
    },
    scrollContent: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    tabItem: {
      paddingVertical: 12,
      paddingHorizontal: 16,
      position: 'relative',
    },
    tabItemCenter: {
      alignItems: 'center',
      justifyContent: 'center',
    },
    tabText: {
      fontSize: 14,
      color: c.text,
      fontWeight: '400',
    },
    activeTabText: {
      color: c.activeText,
      fontWeight: '600',
    },
    disabledTabText: {
      color: c.disabledText,
    },
    tabIcon: {
      marginBottom: 4,
    },
    indicator: {
      position: 'absolute',
      bottom: 0,
      backgroundColor: c.indicator,
    },
    badge: {
      position: 'absolute',
      top: 4,
      right: 4,
      minWidth: 16,
      height: 16,
      borderRadius: 8,
      backgroundColor: c.badge,
      alignItems: 'center',
      justifyContent: 'center',
      paddingHorizontal: 4,
    },
    badgeText: {
      fontSize: 10,
      color: c.badgeText,
      fontWeight: '600',
    },
  });
};

export default createStyles;
